import axios from 'axios';

// GET /admin/sponsors -> [{ id, name, email, engTokens, techTokens, candidateCount, candidates:[...] }]
export async function getSponsors() {
  try {
    const res = await axios.get('/admin/sponsors');
    return res.data.sponsors || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}
